import { createGlobalStyle } from 'styled-components';
import SofiaProLight from 'assets/fonts/SofiaProLight.woff2';
import SofiaProRegular from 'assets/fonts/SofiaProRegular.woff2';
import SofiaProMedium from 'assets/fonts/SofiaProMedium.woff2';
import SofiaProSemiBold from 'assets/fonts/SofiaProSemiBold.woff2';
import SofiaProBold from 'assets/fonts/SofiaProBold.woff2';
import { fonts, zIndex } from './typography/styles';
import { colors } from './colors';

// otf files converted to woff2 to reduce filesize: https://cloudconvert.com/otf-to-woff2
export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProLight}) format('woff2');
    font-weight: 300; /* light */
  }
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProRegular}) format('woff2');
    font-weight: 400; /* normal */
  }
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProMedium}) format('woff2');
    font-weight: 500; /* "medium" */
  }
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProSemiBold}) format('woff2');
    font-weight: 600; /* "semi-bold" */
  }
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProBold}) format('woff2');
    font-weight: 700; /* "bold" */
  }

  body {
    margin: 0;
    padding: 0;
    font-family: ${fonts.sansSerif};
    background: ${colors.backgroundPrimary};
  }

  .content > div > div > & {
    padding: 0;
  }

  .ui.breadcrumb {
    && {
      padding: 0;
      display: inline-block;
      margin-bottom: 15px;
      background: transparent;
      &,
      &:first-child {
        padding: 5px 0;
      }
      a {
        color: #717171;
        &:hover {
          text-decoration: underline;
          color: #000;
        }
      }
      i.divider {
        margin: 0 10px;
        font-size: 18px;
        vertical-align: text-bottom;
      }
      > span:only-child {
        && {
          color: #717171;
        }
      }
    }
  }

  .ui.header {
    && {
    display: inline-block;
    font-size:  28px;
    font-weight:  400;
    font-family: "Sofia Pro", system-ui, -apple-system, BlinkMacSystemFont, "Avenir Next", Avenir, "Segoe UI", "Lucida Grande", "Helvetica Neue", Helvetica, "Fira Sans", Roboto, Noto, "Droid Sans", Cantarell, Oxygen, Ubuntu, "Franklin Gothic Medium", "Century Gothic", "Liberation Sans", sans-serif;
    }
  }

  .ui.popup {
    max-width: unset;
  }

  [data-radix-popper-content-wrapper] {
    z-index: ${zIndex.popover} !important;
  }
`;
